export const WHATSAPP_NUMBER = "5531920032936";
export const PET_FEE = 200;

export const DECOR_OPTIONS = [
    {
        id: "basica",
        name: "Básica",
        price: 350,
        tagline: "Ambiente aconchegante para momentos especiais",
        items: [
            "Pétalas de rosas sobre a cama",
            "Velas aromáticas decorativas",
            "Balões em formato de coração",
            "Frutas e chocolates finos",
        ],
        ideal: "Ideal para surpresas simples e delicadas",
    },
    {
        id: "premium",
        name: "Premium",
        price: 480,
        tagline: "Cenário encantador para celebrar o amor",
        items: [
            "Cama decorada com pétalas em formato de coração",
            "Balões no teto com fitas vermelhas",
            "Velas aromáticas + luminárias LED",
            "Bandeja com espumante, taças e morangos",
            "Música ambiente personalizada",
        ],
        ideal: "Perfeito para aniversários de namoro ou pedidos especiais",
    },
    {
        id: "luxo",
        name: "Luxo",
        price: 650,
        tagline: "Uma noite inesquecível e cheia de detalhes",
        items: [
            "Caminho de pétalas até o quarto",
            "Cama com decoração personalizada (iniciais do casal em pétalas)",
            "Balões metalizados + cortina de coração",
            "Velas aromáticas + iluminação romântica",
            "Espumante, taças, frutas e fondue de chocolate",
            "Toalhas dobradas em formato de cisnes apaixonados",
        ],
        ideal: "Ideal para noites de núpcias ou datas marcantes",
    },
];

const photos = (id, count) =>
    Array.from({ length: count }, (_, i) => `/chales/${id}/${i + 1}.jpg`);

export const CHALETS = [
    {
        id: "double-a-frame",
        name: "Chalé Double A-Frame",
        price: 1150,
        short: "Amplitude, privacidade e imersão completa na natureza",
        description:
            "Com mais de 200 m² de área útil, o Double A-Frame foi pensado exclusivamente para dois, oferecendo amplitude, privacidade e uma imersão completa na natureza. Aqui, o luxo se revela nos detalhes: alto, grandioso e, ao mesmo tempo, acolhedor. Um convite para viver momentos memoráveis em um espaço que traduz liberdade, conforto absoluto e conexão a dois.",
        amenities: [
            "Piscina privativa com vista",
            "Rede suspensa dentro do chalé",
            "Cozinha completa",
            "Banheira para momentos de relaxamento",
            "Sauna exclusiva",
            "Deck panorâmico para o nascer e o pôr do sol",
        ],
        photos: photos("double-a-frame", 10),
    },
    {
        id: "barnhouse",
        name: "Chalé Barnhouse",
        price: 950,
        short: "Romance, conforto e tranquilidade cercados pela natureza",
        description:
            "Desconecte da rotina e se entregue a momentos únicos com quem você ama. Um espaço exclusivo, cercado pela natureza, pensado para o romance, o conforto e a tranquilidade.",
        amenities: [
            "Banheira de hidromassagem com cromoterapia",
            "Sauna privativa e ducha externa",
            "Cama King Size com ar-condicionado",
            "Sala aconchegante com sofá e TV Smart",
            "Banheiro com duas duchas e enxoval Trussardi",
            "Área externa com fogueira, balanço e vista para a montanha",
        ],
        photos: photos("barnhouse", 10),
    },
    {
        id: "a-frame",
        name: "Chalé A-frame",
        price: 950,
        short: "Aconchego completo com hidromassagem e balanço infinito",
        description:
            "Cozinha equipada com geladeira, micro-ondas, airfryer, churrasqueira e muito mais. Sala ampla com calefator e TV smart, hidromassagem interna para relaxar tomando um bom vinho e uma cama de casal enorme no mezanino. Na área externa: bangalô, sauna, espaço para fogueira e um balanço infinito em formato de pêndulo com vista de tirar o fôlego.",
        amenities: [
            "Cozinha completa com airfryer e churrasqueira",
            "Sala ampla com calefator e TV Smart",
            "Hidromassagem interna",
            "Cama de casal no mezanino",
            "Banheiro com duas duchas e secador",
            "Balanço infinito, bangalô, sauna e fogueira",
        ],
        photos: photos("a-frame", 10),
    },
    {
        id: "scandinavian",
        name: "Chalé Scandinavian",
        price: 1150,
        short: "Painel de vidro com vista infinita no ponto mais alto",
        description:
            "Construído no ponto mais alto da propriedade, o Scandinavian impressiona com um painel de vidro que ocupa toda a fachada e parte da lateral, revelando uma vista que se estende além do olhar — seja do térreo ou do mezanino. Uma rede suspensa na meia altura do pé-direito convida você a relaxar literalmente nas alturas.",
        amenities: [
            "Piscina privativa com vista",
            "Rede suspensa dentro do chalé",
            "Cozinha completa",
            "Banheira para momentos de relaxamento",
            "Sauna exclusiva",
            "Deck panorâmico para o nascer e o pôr do sol",
        ],
        photos: photos("scandinavian", 10),
    },
    {
        id: "cabana-linear",
        name: "Cabana Linear",
        price: 1150,
        short: "Refúgio moderno integrado à natureza",
        description:
            "Um refúgio exclusivo, moderno e integrado à natureza — criado para proporcionar momentos inesquecíveis. Privacidade, sofisticação e conforto em cada detalhe. Perfeita para casais que desejam viver uma experiência única, cercados pela natureza e pelo charme da Rarity.",
        amenities: [
            "Fachada em vidro com vista panorâmica",
            "Banheira de hidromassagem ampla",
            "Piscina privativa com borda infinita",
            "Cama queen com enxoval premium",
            "Cozinha completa e equipada",
            "Deck externo para apreciar o pôr do sol",
        ],
        photos: photos("cabana-linear", 10),
    },
];

export const formatBRL = (value) =>
    new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(value);
